<template>
  <div>
    <div class="row">
      <label v-if="totalParticipants != null && evalParticipants != null" class="col-4 my-auto"><b-icon icon="info-circle"></b-icon> {{ $t('training-view.haveEvaluated', { needed: totalParticipants , done: evalParticipants })}} </label>
      <b-form-group
        id="input-eval-average"
        :label="$t('training-view.average')"
        label-for="input-average"
        label-align="right"
        label-cols-sm="6"
        content-align="left"
        content-cols-sm="6"
        class="col-5"
      >
       <b-form-input
          id="input-average"
          type="number"
          v-model="average"
          disabled
          class="col-lg-3 col-md-5"
          placeholder=""
        ></b-form-input>
      </b-form-group>
      <div class="col-3">
        <b-button variant="primary" class="esep-blue-bg col-lg-6 col-sm-12 my-auto float-right" @click="calculateEvaluation()">
          {{ $t("training-view.calculate")}}</b-button>
      </div>
    </div>
    <hr />
    <b-table 
      :items="evaluationItems"
      :fields="fields"
      responsive
      show-empty
      thead-class="esep-blue-bg text-light"
    > 

      <template v-slot:empty="">
        <h6>{{ $t("training-view.emptyEvalTotalTable") }}</h6>
      </template>

    </b-table>
  </div>
</template>

<script>
import trainingService from '../../services/training.service';
import { handleApiError } from "../../services/error.service";

export default {
  props: {
    activity: {
      type: Object
    }
  },
  mounted() {
    this.getEvaluation();
    this.getEvaluationAverage();
    this.getActivitysEvaluationParticipants();
  },
  data() {
    return {
      average: null,
      evaluationItems: null,
      fields: [
        { key: "comments", label: "Κριτήριο Αξιολόγησης", sortable: false, class: 'text-left'},
        { key: "evaluationValue", label: "Βαθμός", sortable: false, class: 'text-left'}
      ],
      evalParticipants: null,
      totalParticipants: null
    }
  },
  methods: {
    getEvaluationAverage() {
      trainingService.getActivitysEvaluationAverage(this.activity.id).then(
        (response) => {
          this.$log.debug("evaluation avg")
          this.$log.debug(response.data)
          this.average = response.data.result;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getActivitysEvaluationParticipants() {
      trainingService.getActivitysEvaluationParticipants(this.activity.id).then(
        (response) => {
          this.evalParticipants = response.data.evalParticipants;
          this.totalParticipants = response.data.totalParticipants;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    getEvaluation(){
      trainingService.getActivitysEvaluation(this.activity.id).then(
        (response) => {
          this.$log.debug('evaluationByCriteria')
          this.$log.debug(response.data);
          // let evalItems = [];
          // response.data.forEach(evalItem => {
          //   let item = {criteria: evalItem.criteria, trainer: evalItem.activitySession.trainer, evaluationValue: evalItem.evaluationValue}
          //   evalItems.push(item);
          // });
          this.evaluationItems = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    },
    calculateEvaluation() {
      trainingService.calculateActivitysEvaluation(this.activity.id).then(
        (response) => {
          this.$log.debug(response.data);
          this.evaluationItems = response.data;
          this.getEvaluationAverage();
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.$emit('error:api', errorMessage);
        }
      )
    }
  }
}
</script>